import { render, staticRenderFns } from "./BlogHeader.vue?vue&type=template&id=27775723&scoped=true"
import script from "./BlogHeader.vue?vue&type=script&lang=js"
export * from "./BlogHeader.vue?vue&type=script&lang=js"
import style0 from "./BlogHeader.vue?vue&type=style&index=0&id=27775723&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27775723",
  null
  
)

export default component.exports